import { render, staticRenderFns } from "./MarkedItems.vue?vue&type=template&id=5fddf8d7&"
import script from "./MarkedItems.vue?vue&type=script&lang=js&"
export * from "./MarkedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports